import React, { useEffect, useMemo, useRef, useState } from "react";
import {
    MapContainer,
    TileLayer,
    FeatureGroup,
    LayersControl,
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import { useParams, Link, useNavigate } from "react-router-dom";

import Selectlist from "../components/POI/Selectlist";
import { useTranslate } from "../hooks/LanguageProvider";
import { parseGeofenceAttributes, parseGeofencing, calculateSurfaceOrLength, Geofence, searchMapbox, searchMapboxRoute } from "../utilities/functions";
import { toast, Bounce } from "react-toastify";
import { Button } from "react-bootstrap";

L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});
const backendUrl = process.env.REACT_APP_BACKEND_URL;

const { BaseLayer } = LayersControl;

// interface Geofence {
//     id: number;
//     type: "circle" | "polygon" | "polyline" | "marker" | "rectangle";
//     center?: [number, number];
//     radius?: number;
//     positions?: [number, number][];
//     position?: [number, number];
// }

interface UserInterface {
    id_user: number;
    nom_user: string;
    prenom_user: string;
}

interface GeofenceCalcule {
    id: number;
    type?: "circle" | "polygon" | "polyline" | "marker" | "rectangle";
    positions?: [number, number][]; // La propriété positions peut être optionnelle
}

interface POIInterface {
    idgeof: number;
    codegeof: string;
    namegeof: string;
    descriptiongeof: string;
    username_user?: string;
    etatgeof: string;
    areageof: string;
    datecreategeof: string;
    tolerance: number;
    user_id: number;
}

interface MapboxDraftPoint {
    id: string;
    label: string;
    position: [number, number];
}

const POI: React.FC = () => {
    const mapRef = useRef<L.Map | null>(null);
    const editControlRef = useRef<any>(null);
    const featureGroupRef = useRef<any>(null);
    const routePreviewLayerRef = useRef<L.Polyline | null>(null);
    const routePointLayerRefs = useRef<L.Marker[]>([]);
    const mapboxEditPreviewLayerRef = useRef<L.Polyline | null>(null);
    const mapboxEditMarkerRefs = useRef<L.Marker[]>([]);
    const mapboxEditingGeofenceRef = useRef<Geofence | null>(null);
    const mapboxWaypointClickHandlerRef = useRef<((latLng: L.LatLng, geofence: Geofence) => void) | null>(null);
    const lineDrawerIconLayerRefs = useRef<L.Marker[]>([]);
    const [step, setStep] = useState(1);
    const { translate } = useTranslate();
    const id_user = localStorage.getItem("userid");
    const { id_poi } = useParams<{ id_poi?: string }>();
    let [POI, setPOI] = useState<POIInterface>({
        idgeof: parseInt(id_poi ?? "0", 10),
        codegeof: "",
        namegeof: "",
        descriptiongeof: "",
        etatgeof: "",
        areageof: "",
        datecreategeof: "",
        tolerance: 0,
        user_id: parseInt(id_user ?? "0", 10),
    });

    const navigate = useNavigate();
    let [geofences, setGeofences] = useState<Geofence[]>([]);
    const [selectedGeofenceId, setSelectedGeofenceId] = useState<number | null>(null);
    const [editingGeofenceId, setEditingGeofenceId] = useState<number | null>(null);
    const [recalculatingGeofenceId, setRecalculatingGeofenceId] = useState<number | null>(null);
    const [, setOptimizedGeofenceId] = useState<number | null>(null);
    const [mapboxEditingGeofenceId, setMapboxEditingGeofenceId] = useState<number | null>(null);
    const [traceDrawerOpen, setTraceDrawerOpen] = useState(false);
    const [upadteCodegeof, setUpadtecodegeof] = useState("");
    const [buttonClicked, setButtonClicked] = useState(false);
    const [mapCenter, setMapCenter] = useState<[number, number]>([30.5670197, 4.6911217]);
    const [mapZoom, setMapZoom] = useState<number>(6);
    const [usersOptions, setUsersOptions] = useState<any[]>([{ value: "Aucun", label: "Aucun" },]);
    const [Users, setUsers] = useState<UserInterface[]>([]);
    const [user, setUser] = useState<UserInterface>({
        id_user: parseInt(id_user ?? '0', 10) || 0,
        nom_user: "",
        prenom_user: ""
    });

    const geofenceColors: Record<NonNullable<Geofence["type"]>, string> = {
        circle: "#0d6efd",
        polygon: "#198754",
        rectangle: "#fd7e14",
        polyline: "#dc3545",
        marker: "#6f42c1",
    };

    const verifyUsername = () => {
        // Votre logique pour vérifier le nom d'utilisateur ici
    };

    const getGeofenceColor = (type?: Geofence["type"], fallback = "#0d6efd") =>
        type ? geofenceColors[type] : fallback;

    const withGeofenceColor = (geofence: Geofence): Geofence => ({
        ...geofence,
        color: geofence.color || getGeofenceColor(geofence.type),
    });

    const getGeofenceStyle = (geofence: Geofence): L.PathOptions => {
        const color = geofence.color || getGeofenceColor(geofence.type);
        const isSelected = selectedGeofenceId === geofence.id;
        return {
            color,
            fillColor: color,
            fillOpacity: geofence.type === "polyline" ? 0 : isSelected ? 0.28 : 0.18,
            opacity: isSelected ? 1 : 0.9,
            weight: isSelected ? 6 : geofence.type === "polyline" ? 4 : 3,
        };
    };

    const getGeofenceLabel = (geofence: Geofence, index: number) => {
        const labels: Record<NonNullable<Geofence["type"]>, string> = {
            circle: "Cercle",
            polygon: "Zone",
            rectangle: "Rectangle",
            polyline: "Ligne",
            marker: "Marker",
        };

        return `${labels[geofence.type || "polygon"] || "Trace"} ${index + 1}`;
    };

    const getGeofenceDisplayName = (geofence: Geofence, index: number) => {
        const name = POI.namegeof?.trim() || POI.codegeof?.trim() || "Geofence";
        return `${name} - ${getGeofenceLabel(geofence, index)}`;
    };

    const parsePOIGeofences = (areageof: string, id: number): Geofence[] => {
        if (!areageof) return [];

        return areageof
            .split(";")
            .map((item) => item.trim())
            .filter(Boolean)
            .map((item, index) => withGeofenceColor(parseGeofenceAttributes(item, id + index)));
    };

    const getLayerGeofence = (layer: L.Layer): Geofence | null => {
        const leafletId = (layer as any)._geofenceId || L.Util.stamp(layer);

        if (layer instanceof L.Circle) {
            const latLng = layer.getLatLng();
            return withGeofenceColor({
                id: leafletId,
                type: "circle",
                center: [latLng.lat, latLng.lng],
                radius: parseFloat(layer.getRadius().toFixed(2)),
            });
        }

        if (layer instanceof L.Rectangle) {
            const bounds = layer.getBounds();
            const southWest = bounds.getSouthWest();
            const northEast = bounds.getNorthEast();
            const positions: [number, number][] = [
                [southWest.lat, southWest.lng],
                [southWest.lat, northEast.lng],
                [northEast.lat, northEast.lng],
                [northEast.lat, southWest.lng],
            ];
            return withGeofenceColor({
                id: leafletId,
                type: "rectangle",
                positions,
            });
        }

        if (layer instanceof L.Polygon) {
            const latLngs = layer.getLatLngs() as L.LatLng[] | L.LatLng[][];
            const points = Array.isArray(latLngs[0]) ? (latLngs[0] as L.LatLng[]) : (latLngs as L.LatLng[]);
            return withGeofenceColor({
                id: leafletId,
                type: "polygon",
                positions: points.map((latLng) => [latLng.lat, latLng.lng] as [number, number]),
            });
        }

        if (layer instanceof L.Polyline) {
            const latLngs = layer.getLatLngs() as L.LatLng[];
            return withGeofenceColor({
                id: leafletId,
                type: "polyline",
                positions: latLngs.map((latLng) => [latLng.lat, latLng.lng] as [number, number]),
            });
        }

        if (layer instanceof L.Marker) {
            const latLng = layer.getLatLng();
            return withGeofenceColor({
                id: leafletId,
                type: "marker",
                position: [latLng.lat, latLng.lng],
            });
        }

        return null;
    };

    const createLayerFromGeofence = (geofence: Geofence): L.Layer | null => {
        const options = getGeofenceStyle(geofence);
        let layer: L.Layer | null = null;

        if (geofence.type === "circle" && geofence.center && geofence.radius) {
            layer = L.circle(geofence.center, { ...options, radius: geofence.radius });
        }

        if (geofence.type === "polygon" && geofence.positions) {
            layer = L.polygon(geofence.positions, options);
        }

        if (geofence.type === "rectangle" && geofence.positions) {
            layer = L.polygon(geofence.positions, options);
        }

        if (geofence.type === "polyline" && geofence.positions) {
            layer = L.polyline(geofence.positions, options);
        }

        if (geofence.type === "marker" && geofence.position) {
            layer = L.marker(geofence.position, { draggable: true });
        }

        if (layer) {
            (layer as any)._geofenceId = geofence.id;
            layer.on("click", () => {
                setSelectedGeofenceId(geofence.id);
                setTraceDrawerOpen(true);
            });
        }

        return layer;
    };

    const focusGeofence = (geofence: Geofence) => {
        const map = mapRef.current;
        if (!map) return;

        const coordinates = geofence.positions || (geofence.center ? [geofence.center] : geofence.position ? [geofence.position] : []);
        if (coordinates.length > 1) {
            map.fitBounds(L.latLngBounds(coordinates), { padding: [40, 40], maxZoom: 17 });
        } else if (coordinates.length === 1) {
            map.setView(coordinates[0], 17);
        }
    };

    const getLineActionPosition = (geofence: Geofence): [number, number] | null => {
        if (geofence.type !== "polyline" || !geofence.positions?.length) return null;
        return geofence.positions[Math.floor(geofence.positions.length / 2)];
    };

    const clearLineDrawerIcons = () => {
        lineDrawerIconLayerRefs.current.forEach((marker) => marker.remove());
        lineDrawerIconLayerRefs.current = [];
    };

    const addLineDrawerIcon = (geofence: Geofence) => {
        const map = mapRef.current;
        const position = getLineActionPosition(geofence);
        if (!map || !position) return;

        const marker = L.marker(position, {
            interactive: true,
            icon: L.divIcon({
                className: "poi-line-drawer-icon",
                html: '<i class="las la-sliders-h"></i>',
                iconSize: [34, 34],
                iconAnchor: [17, 17],
            }),
        }).addTo(map);

        marker.on("click", (event: L.LeafletMouseEvent) => {
            L.DomEvent.stopPropagation(event);
            setSelectedGeofenceId(geofence.id);
            setTraceDrawerOpen(true);
        });

        lineDrawerIconLayerRefs.current.push(marker);
    };

    const startEditMode = (geofence?: Geofence) => {
        if (geofence) {
            setSelectedGeofenceId(geofence.id);
            setEditingGeofenceId(geofence.id);
            setMapboxEditingGeofenceId(null);
            setTraceDrawerOpen(true);
            focusGeofence(geofence);
        }

        window.setTimeout(() => {
            const editButton = document.querySelector<HTMLAnchorElement>(".leaflet-draw-edit-edit:not(.leaflet-disabled)");
            if (editButton) {
                editButton.click();
                return;
            }

            setEditingGeofenceId(null);
            toast.warn("Aucune forme modifiable sur la carte", {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });
        }, 0);
    };

    const clearMapboxEditLayers = () => {
        mapboxEditMarkerRefs.current.forEach((marker) => marker.remove());
        mapboxEditMarkerRefs.current = [];
        mapboxEditPreviewLayerRef.current?.remove();
        mapboxEditPreviewLayerRef.current = null;
    };

    const applyMapboxRouteToGeofence = async (
        geofence: Geofence,
        start: [number, number],
        end: [number, number],
        waypoints: [number, number][] = []
    ) => {
        setRecalculatingGeofenceId(geofence.id);
        try {
            const route = await searchMapboxRoute(start, end, waypoints);
            const updatedGeofence = withGeofenceColor({
                ...geofence,
                positions: route.positions,
            });
            const nextGeofences = geofences.map((item) =>
                item.id === geofence.id ? updatedGeofence : item
            );

            refreshPOI(nextGeofences);
            mapboxEditingGeofenceRef.current = updatedGeofence;
            setSelectedGeofenceId(geofence.id);
            setOptimizedGeofenceId(geofence.id);
            focusGeofence(updatedGeofence);

            mapboxEditPreviewLayerRef.current?.remove();
            if (mapRef.current) {
                mapboxEditPreviewLayerRef.current = L.polyline(route.positions, {
                    color: "#15803d",
                    weight: 6,
                    opacity: 0.9,
                    dashArray: "10 6",
                }).addTo(mapRef.current);
                mapboxEditPreviewLayerRef.current.on("click", (event: L.LeafletMouseEvent) => {
                    mapboxWaypointClickHandlerRef.current?.(event.latlng, geofence);
                });
            }
        } catch (error) {
            toast.warn("Mapbox n'a pas trouve d'itineraire pour ces points", {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });
        } finally {
            setRecalculatingGeofenceId(null);
        }
    };

    const startMapboxRouteEdit = (geofence: Geofence) => {
        if (geofence.type !== "polyline" || !geofence.positions || geofence.positions.length < 2 || !mapRef.current) {
            toast.warn("Cette geofence line n'a pas assez de points", {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });
            return;
        }

        clearMapboxEditLayers();
        mapboxEditingGeofenceRef.current = geofence;
        setSelectedGeofenceId(geofence.id);
        setEditingGeofenceId(null);
        setMapboxEditingGeofenceId(geofence.id);
        setTraceDrawerOpen(true);

        const startPosition = geofence.positions[0];
        const endPosition = geofence.positions[geofence.positions.length - 1];
        const waypointMarkers: L.Marker[] = [];
        const startMarker = L.marker(startPosition, { draggable: true })
            .addTo(mapRef.current)
            .bindTooltip("Depart", { direction: "top" });
        const endMarker = L.marker(endPosition, { draggable: true })
            .addTo(mapRef.current)
            .bindTooltip("Arrivee", { direction: "top" });

        mapboxEditMarkerRefs.current = [startMarker, endMarker];
        mapboxEditPreviewLayerRef.current = L.polyline(geofence.positions, {
            color: "#15803d",
            weight: 6,
            opacity: 0.9,
            dashArray: "10 6",
        }).addTo(mapRef.current);

        const recalculateFromMarkers = () => {
            const startLatLng = startMarker.getLatLng();
            const endLatLng = endMarker.getLatLng();
            const waypoints = waypointMarkers.map((marker) => {
                const latLng = marker.getLatLng();
                return [latLng.lat, latLng.lng] as [number, number];
            });
            applyMapboxRouteToGeofence(
                mapboxEditingGeofenceRef.current || geofence,
                [startLatLng.lat, startLatLng.lng],
                [endLatLng.lat, endLatLng.lng],
                waypoints
            );
        };

        const addMapboxWaypoint = (latLng: L.LatLng, sourceGeofence: Geofence) => {
            if (waypointMarkers.length >= 8) {
                toast.warn("Maximum 8 points intermediaires pour ce trajet", {
                    position: "bottom-right",
                    autoClose: 2200,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    transition: Bounce,
                });
                return;
            }

            const marker = L.marker([latLng.lat, latLng.lng], { draggable: true })
                .addTo(mapRef.current!)
                .bindTooltip(`Point ${waypointMarkers.length + 1}`, { direction: "top" });

            marker.on("dragend", recalculateFromMarkers);
            marker.on("contextmenu", () => {
                marker.remove();
                const markerIndex = waypointMarkers.indexOf(marker);
                if (markerIndex >= 0) waypointMarkers.splice(markerIndex, 1);
                mapboxEditMarkerRefs.current = mapboxEditMarkerRefs.current.filter((item) => item !== marker);
                recalculateFromMarkers();
            });

            waypointMarkers.push(marker);
            mapboxEditMarkerRefs.current.push(marker);
            mapboxEditingGeofenceRef.current = sourceGeofence;
            recalculateFromMarkers();
        };

        mapboxWaypointClickHandlerRef.current = addMapboxWaypoint;
        mapboxEditPreviewLayerRef.current.on("click", (event: L.LeafletMouseEvent) => {
            mapboxWaypointClickHandlerRef.current?.(event.latlng, mapboxEditingGeofenceRef.current || geofence);
        });

        startMarker.on("dragend", recalculateFromMarkers);
        endMarker.on("dragend", recalculateFromMarkers);
        focusGeofence(geofence);
    };

    const stopMapboxRouteEdit = () => {
        clearMapboxEditLayers();
        mapboxEditingGeofenceRef.current = null;
        mapboxWaypointClickHandlerRef.current = null;
        setMapboxEditingGeofenceId(null);
    };

    const recalculateRouteGeofence = async (geofence: Geofence) => {
        if (geofence.type !== "polyline" || !geofence.positions || geofence.positions.length < 2) {
            toast.warn("Cette geofence line n'a pas assez de points", {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });
            return;
        }

        const start = geofence.positions[0];
        const end = geofence.positions[geofence.positions.length - 1];
        setSelectedGeofenceId(geofence.id);
        setRecalculatingGeofenceId(geofence.id);
        setTraceDrawerOpen(true);

        try {
            const route = await searchMapboxRoute(start, end);
            const updatedGeofence = withGeofenceColor({
                ...geofence,
                positions: route.positions,
            });
            const nextGeofences = geofences.map((item) =>
                item.id === geofence.id ? updatedGeofence : item
            );

            refreshPOI(nextGeofences);
            focusGeofence(updatedGeofence);
            setOptimizedGeofenceId(geofence.id);
            setEditingGeofenceId(null);
            toast.success("Chemin Mapbox optimise. Clique sur Modifier chemin optimise.", {
                position: "bottom-right",
                autoClose: 1800,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });
        } catch (error) {
            toast.warn("Mapbox n'a pas trouve d'itineraire pour cette ligne", {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });
        } finally {
            setRecalculatingGeofenceId(null);
        }
    };

    const geometryMetric = useMemo(() => {
        try {
            if (!POI.areageof) return { value: 0, type: "Surface" };
            const geofence = parseGeofencing(POI.areageof.split(";")[0].trim());
            return {
                value: calculateSurfaceOrLength(geofence),
                type: geofence.type === "LINESTRING" ? "Longueur" : "Surface",
            };
        } catch (error) {
            return { value: 0, type: "Surface" };
        }
    }, [POI.areageof]);

    const handleCreated = (e: any) => {
        const { layerType, layer } = e;

        if (layerType === "marker") {
            const position = layer.getLatLng();
            featureGroupRef.current?.removeLayer(layer);
            mapRef.current?.removeLayer(layer);
            addManualRoutePoint([position.lat, position.lng]);
            return;
        }

        let newGeofence: Geofence = {
            id: layer._leaflet_id,
            type: layerType,
            color: getGeofenceColor(layerType),
        };

        if (layerType === "circle") {
            const center = layer.getLatLng();
            newGeofence = {
                ...newGeofence,
                center: [center.lat, center.lng], // Convert LatLng to [number, number]
                radius: layer.getRadius(),
            };
        } else if (layerType === "polygon" || layerType === "rectangle") {
            newGeofence = {
                ...newGeofence,
                positions: layer.getLatLngs()[0].map((latlng: L.LatLng) => [latlng.lat, latlng.lng]), // Convert LatLngs to [number, number]
            };
        } else if (layerType === "polyline") {
            newGeofence = {
                ...newGeofence,
                positions: layer.getLatLngs().map((latlng: L.LatLng) => [latlng.lat, latlng.lng]), // Convert LatLngs to [number, number]
            };
        }

        const coloredGeofence = withGeofenceColor(newGeofence);
        setGeofences((prevGeofences) => [...prevGeofences, coloredGeofence]);
        setSelectedGeofenceId(coloredGeofence.id);

        //refreshPOI([newGeofence]);
    };


    const handleEdited = (e: any) => {
        const updatedGeofences: Geofence[] = [];

        e.layers.eachLayer((layer: L.Layer) => {
            const updatedGeofence = getLayerGeofence(layer);
            if (updatedGeofence) {
                updatedGeofences.push(updatedGeofence);
            }
        });

        const mergedGeofences = geofences.map((geofence) =>
            updatedGeofences.find((updated) => updated.id === geofence.id) || geofence
        );

        refreshPOI(mergedGeofences);
        setEditingGeofenceId(null);
        setOptimizedGeofenceId(null);
    };

    const handleDeleted = (e: any) => {
        const deletedGeofenceIds = new Set<number>();

        e.layers.eachLayer((layer: L.Layer) => {
            const geofenceId = (layer as any)._geofenceId || L.Util.stamp(layer);
            deletedGeofenceIds.add(geofenceId);
        });

        const remainingGeofences = geofences.filter((geofence) => !deletedGeofenceIds.has(geofence.id));
        refreshPOI(remainingGeofences);

        if (selectedGeofenceId !== null && deletedGeofenceIds.has(selectedGeofenceId)) {
            setSelectedGeofenceId(null);
            setTraceDrawerOpen(false);
        }

        setEditingGeofenceId(null);
        setOptimizedGeofenceId(null);
    };


    function calculateCenter(geofences: GeofenceCalcule[]): [number, number] {
        let minLat = Infinity;
        let maxLat = -Infinity;
        let minLng = Infinity;
        let maxLng = -Infinity;

        geofences.forEach((geofence) => {
            if (geofence.positions) {
                geofence.positions.forEach(([lat, lng]) => {
                    minLat = Math.min(minLat, lat);
                    maxLat = Math.max(maxLat, lat);
                    minLng = Math.min(minLng, lng);
                    maxLng = Math.max(maxLng, lng);
                });
            }
        });

        return [(minLat + maxLat) / 2, (minLng + maxLng) / 2];
    }

    function calculateZoom(geofences: Geofence[]): number {
        const WORLD_DIM = { height: 256, width: 256 };
        const ZOOM_MAX = 21;

        let minLat = Infinity;
        let maxLat = -Infinity;
        let minLng = Infinity;
        let maxLng = -Infinity;

        geofences.forEach((geofence) => {
            if (geofence.positions) {
                geofence.positions.forEach(([lat, lng]) => {
                    minLat = Math.min(minLat, lat);
                    maxLat = Math.max(maxLat, lat);
                    minLng = Math.min(minLng, lng);
                    maxLng = Math.max(maxLng, lng);
                });
            }
        });

        const latFraction = (maxLat - minLat) / 180;
        const lngFraction = (maxLng - minLng) / 360;

        const latZoom = Math.floor(Math.log2((WORLD_DIM.height / 256) / latFraction));
        const lngZoom = Math.floor(Math.log2((WORLD_DIM.width / 256) / lngFraction));

        return Math.min(latZoom, lngZoom, ZOOM_MAX);
    }

    const getPOI = async (idPoi: string, idUser: string) => {
        try {
            const bodyData = JSON.stringify({
                id_poi: idPoi,
                id_user: idUser,
            });

            const POIResponse = await fetch(`${backendUrl}/api/poi/find`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: bodyData,
                mode: "cors",
            });

            if (!POIResponse.ok) {
                console.error("Erreur lors de la récupération du POI");
                return;
            }

            const data = await POIResponse.json();

            const mappedGeofences = data.flatMap((item: POIInterface) => {
                return parsePOIGeofences(item.areageof, item.idgeof);
            });

            setPOI(data[0]);
            POI = data[0];
            if (POI) setUpadtecodegeof(POI?.codegeof)
            setGeofences(mappedGeofences);

            let center: [number, number] = [51.505, -0.09];
            let zoom: number = 13;

            const geofenceWithCenter = mappedGeofences.find((geofence: Geofence) =>
                (geofence.type === "circle" || geofence.type === "marker") && geofence.center
            );

            if (geofenceWithCenter) {
                center = geofenceWithCenter.center!;
                zoom = 16;
            } else {
                const geofenceWithPositions = mappedGeofences.find((geofence: Geofence) =>
                    (geofence.type === "polygon" || geofence.type === "polyline" || geofence.type === "rectangle") && geofence.positions
                );

                if (geofenceWithPositions) {


                    center = calculateCenter([geofenceWithPositions]);
                    zoom = calculateZoom([geofenceWithPositions]);
                }
            }

            setMapCenter(center);
            setMapZoom(zoom);



            if (mapRef.current) {
                mapRef.current.setView(center, zoom);
            }

        } catch (error) {
            console.error(error);
        }
    };



    /*************************************************************************************************** */


    const refreshMapFromPOI = () => {
        try {
            if (POI) {
                // Analyser les géofences à partir de POI.areageof
                const geofencesArray = parsePOIGeofences(POI.areageof, POI.idgeof);

                // Mettre à jour l'état des géofences avec les géofences du POI
                setGeofences(geofencesArray);

                // Déterminer le centre et le zoom de la carte en fonction des géofences
                let center: [number, number] = [51.505, -0.09];
                let zoom: number = 13;

                const geofenceWithCenter = geofencesArray.find((geofence: Geofence) =>
                    (geofence.type === "circle" || geofence.type === "marker") && geofence.center
                );

                if (geofenceWithCenter && geofenceWithCenter.center) {
                    center = geofenceWithCenter.center;
                    zoom = 16;
                } else {
                    const geofenceWithPositions = geofencesArray.find((geofence: Geofence) =>
                        (geofence.type === "polygon" || geofence.type === "polyline" || geofence.type === "rectangle") && geofence.positions
                    );

                    if (geofenceWithPositions && geofenceWithPositions.positions) {
                        center = calculateCenter([geofenceWithPositions]);
                        zoom = calculateZoom([geofenceWithPositions]);
                    }
                }

                // Mettre à jour le centre et le zoom de la carte
                setMapCenter(center);
                setMapZoom(zoom);

                // Mettre à jour la vue de la carte
                if (mapRef.current) {
                    mapRef.current.setView(center, zoom);
                }

                // Recharger les géofences sur la carte sans utiliser updateGeofencesOnMap
                if (featureGroupRef.current) {
                    // Effacer les couches existantes du groupe de fonctionnalités
                    featureGroupRef.current.clearLayers();

                    // Parcourir les géofences et les ajouter au groupe de fonctionnalités
                    geofencesArray.forEach((geofence) => {
                        let layer: L.Layer | null = null;

                        if (geofence.type === "circle" && geofence.center && geofence.radius) {
                            layer = L.circle(geofence.center, { radius: geofence.radius });
                        } else if (geofence.type === "polygon" && geofence.positions) {
                            layer = L.polygon(geofence.positions);
                        } else if (geofence.type === "rectangle" && geofence.positions) {
                            if (geofence.positions.length === 2) {
                                const bounds: L.LatLngBoundsLiteral = [
                                    [geofence.positions[0][0], geofence.positions[0][1]],
                                    [geofence.positions[1][0], geofence.positions[1][1]],
                                ];
                                layer = L.rectangle(bounds);
                            } else {
                                layer = L.polygon(geofence.positions);
                            }
                        } else if (geofence.type === "polyline" && geofence.positions) {
                            layer = L.polyline(geofence.positions);
                        } else if (geofence.type === "marker" && geofence.position) {
                            layer = L.marker(geofence.position, { draggable: true });
                        }

                        if (layer) {
                            // Ajouter le layer au groupe de fonctionnalités
                            featureGroupRef.current.addLayer(layer);
                        }
                    });
                }
            }
        } catch (error) {
            console.error(error);
        }
    };



    const refreshPOI = (updatedGeofences: Geofence[]) => {
        const normalizedGeofences = updatedGeofences.map(withGeofenceColor);
        setGeofences(normalizedGeofences);
        loadGeofencesToMap(normalizedGeofences);

        // Convert the updated geofences into a string for the `areageof` field
        const newAreageof = convertGeofencesToAreageof(normalizedGeofences);

        // Update the POI state with the new `areageof` value
        setPOI(prevPOI => {
            if (!prevPOI) {
                return {
                    // Provide default values for all properties of POIInterface
                    areageof: '',
                    idgeof: 0,
                    codegeof: '',
                    namegeof: '',
                    descriptiongeof: '',
                    username_user: '',
                    etatgeof: '',
                    datecreategeof: '',
                    tolerance: 0,
                    user_id: 0,
                };
            }

            return {
                ...prevPOI,
                areageof: newAreageof,
            };
        });


    };


    let newGeofences: Geofence[];

    // Supposons que vous ayez une fonction qui manipule un layer
    const saveCurrentGeofences = (additionalGeofences: Geofence[] = []) => {
        const layers = featureGroupRef.current?.getLayers() || [];

        // Assigner le type `L.Layer` au paramètre `layer`
        newGeofences = layers.map((layer: L.Layer) => {
            const leafletId = L.Util.stamp(layer); // Utilisation de L.Util.stamp() pour obtenir l'ID

            // Vérification du type spécifique du layer
            if (layer instanceof L.Circle) {
                const latLng = layer.getLatLng();
                return {
                    id: leafletId,
                    type: "circle",
                    center: [latLng.lat, latLng.lng], // Assurez-vous que center est un tableau [lat, lng]
                    radius: layer.getRadius(),
                };
            } else if (layer instanceof L.Rectangle) {
                const bounds = layer.getBounds();
                const southWest = bounds.getSouthWest();
                const northEast = bounds.getNorthEast();
                const positions: [number, number][] = [
                    [southWest.lat, southWest.lng],
                    [southWest.lat, northEast.lng],
                    [northEast.lat, northEast.lng],
                    [northEast.lat, southWest.lng],
                ];
                return {
                    id: leafletId,
                    type: "rectangle",
                    color: getGeofenceColor("rectangle"),
                    positions,
                };
            } else if (layer instanceof L.Polygon) {
                const latLngs = layer.getLatLngs() as L.LatLng[][]; // Peut être un tableau de tableaux
                const positions = latLngs.flat().map(latLng => [latLng.lat, latLng.lng] as [number, number]);
                return {
                    id: leafletId,
                    type: layer instanceof L.Polygon ? "polygon" : "rectangle",
                    positions,
                };
            } else if (layer instanceof L.Polyline) {
                const latLngs = layer.getLatLngs() as L.LatLng[];
                const positions = latLngs.map(latLng => [latLng.lat, latLng.lng] as [number, number]);
                return {
                    id: leafletId,
                    type: "polyline",
                    positions,
                };
            } else if (layer instanceof L.Marker) {
                const latLng = layer.getLatLng();
                return {
                    id: leafletId,
                    type: "marker",
                    position: [latLng.lat, latLng.lng], // Assurez-vous que position est un tableau [lat, lng]
                };
            }

            // Si ce n'est pas un type supporté, retourner null
            return null;
        }).filter(Boolean) as Geofence[];

        const geofencesToSave = [...newGeofences, ...additionalGeofences].map(withGeofenceColor);
        refreshPOI(geofencesToSave);
        return geofencesToSave;
    }


    useEffect(() => {
        loadGeofencesToMap();
    }, [step, geofences, selectedGeofenceId]);

    const loadGeofencesToMap = (geofencesToLoad: Geofence[] = geofences) => {
        if (featureGroupRef.current) {
            clearLineDrawerIcons();
            featureGroupRef.current.clearLayers();

            geofencesToLoad.forEach(geofence => {
                const layer = createLayerFromGeofence(geofence);
                if (layer) {
                    layer.addTo(featureGroupRef.current);
                }
                addLineDrawerIcon(geofence);
            });

            setTimeout(() => {
                if (editControlRef.current) {
                    editControlRef.current._toolbars.edit._checkDisabled();
                }
            }, 100);
        }
    };




    const extractLatLng = (latLngString: string): { lat: number, lng: number } => {
        const match = latLngString.match(/LatLng\(([^,]+),\s*([^)]+)\)/);
        let lat = 0;
        let lng = 0;
        if (match) {
            lat = parseFloat(match[1]);
            lng = parseFloat(match[2]);

        }
        return { lat, lng };
    };


    const convertLatLngArray = (latLngArray: [number, number][]): string =>
        latLngArray.map(([lat, lng]) => `${lat} ${lng}`).join(',');

    const convertLatLngLINESTRINGArray = (latLngArray: [number, number][]): string =>
        latLngArray.map(([lat, lng]) => `${lat} ${lng}`).join(', ');


    const convertGeofencesToAreageof = (geofences: Geofence[]): string => {
        const geofenceStrings = geofences.map(geofence => {
            switch (geofence.type) {
                case "circle":
                    if (geofence.center && typeof geofence.center[0] === 'number' && typeof geofence.center[1] === 'number' && geofence.radius) {
                        const [lat, lng] = geofence.center;
                        return `CIRCLE(${lat},${lng},${geofence.radius})`;
                    }
                    return "";

                case "polygon":
                    if (geofence.positions && Array.isArray(geofence.positions)) {
                        const positions = convertLatLngArray(geofence.positions);
                        return `POLYGON((${positions}))`;
                    }
                    return "";

                case "rectangle":
                    if (geofence.positions && Array.isArray(geofence.positions)) {
                        const positions = convertLatLngArray(geofence.positions);
                        return `RECTANGLE(${positions})`;
                    }
                    return "";

                case "polyline":
                    if (geofence.positions && Array.isArray(geofence.positions)) {
                        const positions = convertLatLngLINESTRINGArray(geofence.positions);
                        return `LINESTRING(${positions})`;
                    }
                    return "";




                case "marker":
                    if (geofence.position && typeof geofence.position[0] === 'number' && typeof geofence.position[1] === 'number') {
                        const [lat, lng] = geofence.position;
                        return `MARKER(${lat},${lng})`;
                    }
                    return "";

                default:
                    return "";
            }
        }).filter(str => str.length > 0);

        return geofenceStrings.join('; ');
    };



    useEffect(() => {
        if (id_poi && id_user) {
            getPOI(id_poi, id_user);
        }
    }, []);





    const addPOI = () => {
        if (routeLoading) {
            toast.warn("Le calcul de l'itineraire est encore en cours", {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });
            return;
        }

        const routeGeofence = routePreview.length >= 2
            ? withGeofenceColor({
                id: Date.now(),
                type: "polyline",
                positions: routePreview,
            })
            : null;

        saveCurrentGeofences(routeGeofence ? [routeGeofence] : []);
        if (routeGeofence) {
            clearRouteDraft();
            setSelectedGeofenceId(routeGeofence.id);
        }
        // console.log("Step 2");
        // console.log(POI.areageof);

        setStep(2);
    };

    const wizardBack = () => {

        // saveCurrentGeofences()

        // if(id_poi && id_user)   getPOI(id_poi, id_user);

        setStep(step - 1);

        setTimeout(() => { refreshMapFromPOI() }, 300);

        // console.log("Step 1");
        // console.log(POI.areageof);;


    };



    const findUserById = (
        id: number
    ): { value: number; label: string } | undefined => {
        const foundUser = Users.find((user) => user.id_user === id);

        if (foundUser) {
            const { id_user, nom_user, prenom_user } = foundUser;
            return { value: id_user, label: `${nom_user} ${prenom_user || ""}` };
        }

        return undefined;
    };

    useEffect(() => {
        if (id_user) {
            getUser(id_user);
        }
    }, [id_user]);

    const getUser = async (user_id: any) => {
        try {
            const res = await fetch(`${backendUrl}/api/users/find/${user_id}`, {
                mode: "cors",
            });

            if (!res.ok) {
                console.error("Erreur lors de la récupération des utilisateurs");
                return;
            }

            const usersData = await res.json();
            setUsers(usersData);

            const usersOptionsData = usersData.map((user: any) => ({
                value: user.id_user,
                label: `${user.nom_user} ${user.prenom_user || ""}`,
            }));

            setUsersOptions(usersOptionsData);
        } catch (error) {
            console.error("Erreur lors de la récupération des utilisateurs", error);
        }
    };



    const handleClick = async () => {
        if (POI) {
            await updatePOI(POI);
        } else {
            console.warn("POI is not defined or empty");
        }
    };

    const updatePOI = async (poi: POIInterface) => {
        const isCodeValid = poi.codegeof.trim().length > 0
        const isNameValid = poi.namegeof.trim().length > 0;
        const isAreaValid = poi.areageof.trim().length > 0;

        if (!isNameValid || !isAreaValid || !isCodeValid) {
            const nameElement = document.getElementById("namegeof");
            if (nameElement) {
                nameElement.style.borderColor = isNameValid ? "#ced4da" : "red";
            }

            const areaElement = document.getElementById("areageof");
            if (areaElement) {
                areaElement.style.borderColor = isAreaValid ? "#ced4da" : "red";
            }

            const codegeofElement = document.getElementById("codegeof");
            if (codegeofElement) {
                codegeofElement.style.borderColor = isCodeValid ? "#ced4da" : "red";
            }


            toast.warn("Please fill in all required fields", {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });
            setButtonClicked(false);
            return;
        } else {
            try {
                const resCheck = await fetch(`${backendUrl}/api/poi/check`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    mode: "cors",
                    body: JSON.stringify({
                        codegeof: poi.codegeof,
                        updatedCodeGeof: upadteCodegeof,
                        updated: (upadteCodegeof === poi.codegeof) ? 0 : 1
                    }),
                });

                if (!resCheck.ok) {
                    throw new Error("Network response was not ok");
                }

                const jsonResponse = await resCheck.json();

                // eslint-disable-next-line eqeqeq
                if (jsonResponse.poi_count == 0) {
                    const resUpdate = await fetch(`${backendUrl}/api/poi/update`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        mode: "cors",
                        body: JSON.stringify(
                            {
                                idgeof: poi.idgeof,
                                codegeof: poi.codegeof,
                                namegeof: poi.namegeof,
                                descriptiongeof: poi.descriptiongeof,
                                etatgeof: poi.etatgeof,
                                areageof: poi.areageof,
                                tolerance: poi.tolerance,
                                user_id: poi.user_id,
                            }
                        ),
                    });

                    if (!resUpdate.ok) {
                        toast.warn("Can't update POI", {
                            position: "bottom-right",
                            autoClose: 2400,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                            transition: Bounce,
                        });
                        console.error("Error updating POI");
                        return;
                        setButtonClicked(false);
                    }

                    toast.success("POI updated successfully", {
                        position: "bottom-right",
                        autoClose: 2400,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        transition: Bounce,
                    });
                    setButtonClicked(false);

                    navigate("/POIs");

                } else {
                    toast.warn("The POI exists", {
                        position: "bottom-right",
                        autoClose: 2400,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        transition: Bounce,
                    });
                    setButtonClicked(false);
                }
            } catch (error) {
                toast.warn("Can't update POI", {
                    position: "bottom-right",
                    autoClose: 2400,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    transition: Bounce,
                });
                setButtonClicked(false);
            }
        }
    };

    const createPOI = async (poi: POIInterface) => {
        const isCodeValid = poi.codegeof.trim().length > 0;
        const isNameValid = poi.namegeof.trim().length > 0;
        const isAreaValid = poi.areageof.trim().length > 0;


        if (!isNameValid || !isAreaValid || !isCodeValid) {
            const nameElement = document.getElementById("namegeof");
            if (nameElement) {
                nameElement.style.borderColor = isNameValid ? "#ced4da" : "red";
            }

            const areaElement = document.getElementById("areageof");
            if (areaElement) {
                areaElement.style.borderColor = isAreaValid ? "#ced4da" : "red";
            }

            const codegeofElement = document.getElementById("codegeof");
            if (codegeofElement) {
                codegeofElement.style.borderColor = isCodeValid ? "#ced4da" : "red";
            }

            toast.warn("Please fill in all required fields", {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });
            setButtonClicked(false);

            return;
        } else {
            try {
                const resCheck = await fetch(`${backendUrl}/api/poi/check`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    mode: "cors",
                    body: JSON.stringify({
                        codegeof: poi.codegeof,
                        updatedCodeGeof: upadteCodegeof,
                        updated: 0
                    }),
                });

                if (!resCheck.ok) {
                    throw new Error("Network response was not ok");
                }

                const jsonResponse = await resCheck.json();

                if (jsonResponse.poi_count === 0) {


                    let poiData = Object.fromEntries(
                        Object.entries(poi).filter(([_, value]) => value !== null)
                    );


                    const resCreate = await fetch(`${backendUrl}/api/poi/create`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        mode: "cors",
                        body: JSON.stringify(
                            {
                                codegeof: poi.codegeof,
                                namegeof: poi.namegeof,
                                descriptiongeof: poi.descriptiongeof,
                                etatgeof: "Inactive",
                                areageof: poi.areageof,
                                tolerance: poi.tolerance,
                                user_id: poi.user_id,
                            }
                        ),
                    });



                    if (!resCreate.ok) {
                        toast.warn("Can't create POI", {
                            position: "bottom-right",
                            autoClose: 2400,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                            transition: Bounce,
                        });
                        console.error("Error creating POI");
                        return;

                        setButtonClicked(false);
                    }

                    toast.success("POI created successfully", {
                        position: "bottom-right",
                        autoClose: 2400,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        transition: Bounce,
                    });

                    setButtonClicked(false);

                    navigate("/POIs");
                } else {
                    toast.warn("The POI exists", {
                        position: "bottom-right",
                        autoClose: 2400,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        transition: Bounce,
                    });
                    setButtonClicked(false);
                }
            } catch (error) {
                toast.warn("Can't create POI", {
                    position: "bottom-right",
                    autoClose: 2400,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    transition: Bounce,
                });
                setButtonClicked(false);
            }
        }
    };


    const handleChange = (name: any, value: any) => {

        if (POI) {
            setPOI({
                ...POI,
                [name]: value,
            });
        }

    };

    const baseMapOptions = [
        {
            value: "google_roadmap",
            label: "Google Roadmap",
            icon: "http://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}",
        },
        {
            value: "osm",
            label: "OSM",
            icon: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        },
        {
            value: "hot",
            label: "OSM HOT",
            icon: "https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
        },
        {
            value: "dark",
            label: "DARK",
            icon: "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}@2x.png",
        },
        {
            value: "cycle",
            label: "CYCLE MAP",
            icon: "https://dev.{s}.tile.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png",
        },
        {
            value: "google_traffic",
            label: "Google Traffic",
            icon: "https://{s}.google.com/vt/lyrs=m@221097413,traffic&x={x}&y={y}&z={z}",
        },
        {
            value: "google_satellite",
            label: "Google Satellite",
            icon: "https://www.google.com/maps/vt?lyrs=s@189&gl=us&x={x}&y={y}&z={z}",
        },
        {
            value: "google_terrain",
            label: "Google Terrain",
            icon: "https://www.google.com/maps/vt?lyrs=p@189&gl=us&x={x}&y={y}&z={z}",
        },
        //{ value: 'mapbox', label: 'Mapbox', icon: 'https://api.mapbox.com/styles/v1/idenet/ckoytzfxw0mr417mju7fh5kc5.html?title=view&access_token=pk.eyJ1IjoiaWRlbmV0IiwiYSI6ImNqeGs0dHAzbTFlb3UzeXFkOWk1ZWQ5cDIifQ.lpPl03eDGutSjsd0fLaPkw&zoomwheel=true&fresh=true#9/37.78/-122.4241' },
    ];



    const [searchText, setSearchText] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [draftPoints, setDraftPoints] = useState<MapboxDraftPoint[]>([]);
    const [routePoints, setRoutePoints] = useState<MapboxDraftPoint[]>([]);
    const [routePreview, setRoutePreview] = useState<[number, number][]>([]);
    const [routeLoading, setRouteLoading] = useState(false);

    const selectedGeofence = useMemo(
        () => geofences.find((geofence) => geofence.id === selectedGeofenceId) || null,
        [geofences, selectedGeofenceId]
    );

    const geometrySearchResults = useMemo(() => {
        const query = searchText.trim().toLowerCase();
        if (query.length < 2) return [];

        return geofences.filter((geofence, index) => {
            const haystack = [
                `forme ${index + 1}`,
                geofence.type,
                geofence.color,
                geofence.positions?.map(([lat, lng]) => `${lat} ${lng}`).join(" "),
                geofence.center?.join(" "),
                geofence.position?.join(" "),
            ].filter(Boolean).join(" ").toLowerCase();

            return haystack.includes(query);
        });
    }, [geofences, searchText]);


    // Déclare la ref avec le bon type
    const debounceRef = useRef<number | null>(null);

    const handleSearchInput = (value: string) => {
        setSearchText(value);

        // clear previous debounce
        if (debounceRef.current !== null) {
            clearTimeout(debounceRef.current);
        }

        debounceRef.current = window.setTimeout(async () => {
            if (value.length < 2) {
                setSuggestions([]);
                return;
            }

            try {
                const data = await searchMapbox(value);
                setSuggestions(data.features || []);
            } catch (err) {
                console.error("Erreur Mapbox:", err);
                setSuggestions([]);
            }
        }, 300); // 300ms debounce
    };

    const clearRouteDraftLayers = () => {
        routePointLayerRefs.current.forEach((marker) => marker.remove());
        routePointLayerRefs.current = [];
        routePreviewLayerRef.current?.remove();
        routePreviewLayerRef.current = null;
    };

    const drawRouteDraftLayers = (points: MapboxDraftPoint[], route: [number, number][] = []) => {
        const map = mapRef.current;
        if (!map) return;

        clearRouteDraftLayers();
        routePointLayerRefs.current = points.map((point, index) => {
            const marker = L.marker(point.position, { draggable: true })
                .addTo(map)
                .bindTooltip(point.label, { direction: "top" });
            marker.dragging?.enable();

            marker.on("dragend", () => {
                const latLng = marker.getLatLng();
                const nextPoints = points.map((item, pointIndex) =>
                    pointIndex === index
                        ? { ...item, position: [latLng.lat, latLng.lng] as [number, number] }
                        : item
                );

                setRoutePoints(nextPoints);
                loadRoutePreview(nextPoints);
            });

            return marker;
        });

        if (route.length > 1) {
            routePreviewLayerRef.current = L.polyline(route, {
                color: getGeofenceColor("polyline"),
                weight: 5,
                opacity: 0.9,
                dashArray: "8 6",
            }).addTo(map);
            map.fitBounds(L.latLngBounds(route), { padding: [40, 40], maxZoom: 16 });
        } else if (points.length > 0) {
            map.setView(points[points.length - 1].position, 15);
        }
    };

    const loadRoutePreview = async (points: MapboxDraftPoint[]) => {
        if (points.length !== 2) {
            setRoutePreview([]);
            drawRouteDraftLayers(points);
            return;
        }

        setRouteLoading(true);
        try {
            const route = await searchMapboxRoute(points[0].position, points[1].position);
            setRoutePreview(route.positions);
            drawRouteDraftLayers(points, route.positions);
        } catch (error) {
            setRoutePreview([]);
            drawRouteDraftLayers(points);
            toast.warn("Route Mapbox introuvable entre ces deux points", {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });
        } finally {
            setRouteLoading(false);
        }
    };

    const addManualRoutePoint = (position: [number, number]) => {
        setRoutePoints((previousPoints) => {
            const point: MapboxDraftPoint = {
                id: `manual-${Date.now()}`,
                label: `Point ${previousPoints.length >= 2 ? 1 : previousPoints.length + 1}`,
                position,
            };
            const nextPoints = previousPoints.length >= 2 ? [point] : [...previousPoints, point];

            loadRoutePreview(nextPoints);
            return nextPoints;
        });
    };

    const clearRouteDraft = () => {
        setRoutePoints([]);
        setRoutePreview([]);
        clearRouteDraftLayers();
    };

    const transformRouteToGeofenceLine = () => {
        if (routePreview.length < 2) {
            toast.warn("Posez deux markers pour calculer une route", {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });
            return;
        }

        const newGeofence = withGeofenceColor({
            id: Date.now(),
            type: "polyline",
            positions: routePreview,
        });

        refreshPOI([...geofences, newGeofence]);
        clearRouteDraft();
        setSelectedGeofenceId(newGeofence.id);
        focusGeofence(newGeofence);
    };




    const handleSelectSuggestion = (feature: any) => {
        const [lon, lat] = feature.center;
        const map = mapRef.current;
        if (!map) return;

        // Centrer la carte sur le lieu
        map.setView([lat, lon], 15); // ou map.flyTo([lat, lon], 15) pour un centrage animé

        // Mettre à jour l'input et vider les suggestions
        setSearchText(feature.place_name);
        setSuggestions([]);
    };

    const addDraftPointFromFeature = (feature: any) => {
        const [lon, lat] = feature.center;
        const point: MapboxDraftPoint = {
            id: feature.id || `${lat}-${lon}-${Date.now()}`,
            label: feature.place_name || `${lat}, ${lon}`,
            position: [lat, lon],
        };

        setDraftPoints((prev) => {
            const alreadyAdded = prev.some((existing) =>
                Math.abs(existing.position[0] - point.position[0]) < 0.000001 &&
                Math.abs(existing.position[1] - point.position[1]) < 0.000001
            );

            return alreadyAdded ? prev : [...prev, point];
        });

        mapRef.current?.setView(point.position, 15);
        setSearchText("");
        setSuggestions([]);
    };

    const getPolygonFromDraftPoints = (points: MapboxDraftPoint[]): [number, number][] => {
        if (points.length === 2) {
            const [[lat1, lng1], [lat2, lng2]] = points.map((point) => point.position);
            const latPadding = Math.max(Math.abs(lat2 - lat1) * 0.15, 0.001);
            const lngPadding = Math.max(Math.abs(lng2 - lng1) * 0.15, 0.001);

            return [
                [Math.min(lat1, lat2) - latPadding, Math.min(lng1, lng2) - lngPadding],
                [Math.min(lat1, lat2) - latPadding, Math.max(lng1, lng2) + lngPadding],
                [Math.max(lat1, lat2) + latPadding, Math.max(lng1, lng2) + lngPadding],
                [Math.max(lat1, lat2) + latPadding, Math.min(lng1, lng2) - lngPadding],
            ];
        }

        const center = points.reduce(
            (acc, point) => ({
                lat: acc.lat + point.position[0] / points.length,
                lng: acc.lng + point.position[1] / points.length,
            }),
            { lat: 0, lng: 0 }
        );

        return [...points]
            .sort((a, b) => {
                const angleA = Math.atan2(a.position[0] - center.lat, a.position[1] - center.lng);
                const angleB = Math.atan2(b.position[0] - center.lat, b.position[1] - center.lng);
                return angleA - angleB;
            })
            .map((point) => point.position);
    };

    const createPolygonFromDraftPoints = () => {
        if (draftPoints.length < 2) {
            toast.warn("Ajoutez au moins deux points", {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });
            return;
        }

        const positions = getPolygonFromDraftPoints(draftPoints);
        const newGeofence = withGeofenceColor({
            id: Date.now(),
            type: "polygon",
            positions,
        });
        const nextGeofences = [...geofences, newGeofence];

        refreshPOI(nextGeofences);
        setSelectedGeofenceId(newGeofence.id);
        focusGeofence(newGeofence);
        setDraftPoints([]);
    };


    return (
        <>
            <div id="add_alarm_wizard" className="wizard">
                <ul className="steps">
                    <li data-target="#step1" className={step === 1 ? "active-step" : ""}>
                        <span className="badge badge-info">1</span> {translate("Geometry")}{" "}
                        <span className="chevron"></span>
                    </li>
                    <li className="ml-2 mr-2">
                        <i className="las la-exchange-alt"></i>
                    </li>
                    <li data-target="#step2" className={step === 2 ? "active-step" : ""}>
                        <span className="badge badge-info">2</span> {translate("Properties")}
                        <span className="chevron"></span>
                    </li>
                </ul>
            </div>
            <div className="step-content col-12">
                <form
                    id="add_alarm_form"
                    style={{ width: "100%", border: "1px solid #ddd", padding: "15px" }}
                >
                    <input type="hidden" name="step" value={step} />
                    {step === 1 && (
                        <div
                            className="step-pane active panel panel-default"
                            id="step1"
                            style={{ marginTop: "5px", background: "#fff" }}
                        >
                            <div className="panel-body">
                                <div className="row">
                                    <div
                                        className="col-md-6 col-sm-4"
                                        style={{ margin: "8px 0" }}
                                    >
                                        <div className="input-group">
                                            <span className="input-group-addon">
                                                <strong>Etape 1 </strong> Déssinez/Choisir vos points/zones géographique
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        className="col-md-6 col-sm-4"
                                        style={{
                                            display: "inline",
                                            textAlign: "right",
                                            margin: "8px 0",
                                        }}
                                    >
                                        <Link
                                            to={`/pois/`}
                                            className="btn btn-outline-secondary  mr-2"
                                            data-toggle="Cancel"
                                            data-placement="top"
                                            title="Cancel"
                                        >
                                            <i
                                                className="fas fa-chevron-left"
                                                style={{ fontSize: "1.2em" }}
                                            ></i>
                                            Cancel
                                        </Link>

                                        <button
                                            className="btn btn-outline-secondary  mr-2"
                                            type="button"
                                            name="set_params"
                                            onClick={addPOI}
                                        >
                                            <i className="fas fa-chevron-right"></i>&nbsp;Suivant
                                        </button>
                                    </div>
                                    <div>
                                        <MapContainer
                                            center={mapCenter}
                                            zoom={mapZoom}
                                            style={{ height: "70vh", width: "100%", zIndex: "1" }}
                                            ref={mapRef}
                                        >


                                            <div className="poi-map-tools">

                                                <div className="input-group">
                                                    {/* Icône de recherche à gauche */}
                                                    <span className="input-group-text" id="basic-addon1">
                                                        <i className="las la-search"></i>
                                                    </span>

                                                    {/* Input */}
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Rechercher lieu ou forme..."
                                                        id="search-location"
                                                        name="search-location"
                                                        value={searchText}
                                                        onChange={(e) => handleSearchInput(e.target.value)}
                                                        aria-label="Recherche de lieu"
                                                        aria-describedby="basic-addon1"
                                                    />

                                                    {/* X pour vider la recherche */}
                                                    {searchText && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-secondary"
                                                            onClick={() => {
                                                                setSearchText("");
                                                                setSuggestions([]);
                                                            }}
                                                            aria-label="Effacer la recherche"
                                                        >
                                                            <i className="las la-times"></i>
                                                        </button>
                                                    )}
                                                </div>

                                                {routePoints.length > 0 && (
                                                    <div style={{
                                                        backgroundColor: "#fff",
                                                        border: "1px solid #d8dee4",
                                                        borderRadius: 6,
                                                        marginTop: 4,
                                                        padding: 8,
                                                        boxShadow: "0 8px 20px rgba(15, 23, 42, 0.10)"
                                                    }}>
                                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                                                            <span style={{ fontSize: 13, fontWeight: 600, color: "#1f2937" }}>
                                                                Route markers ({routePoints.length}/2)
                                                            </span>
                                                            <div style={{ display: "flex", gap: 6 }}>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-primary"
                                                                    onClick={transformRouteToGeofenceLine}
                                                                    disabled={routePreview.length < 2 || routeLoading}
                                                                >
                                                                    {routeLoading ? "Calcul..." : "Geofence line"}
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary"
                                                                    onClick={clearRouteDraft}
                                                                >
                                                                    Vider
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div style={{ marginTop: 6, fontSize: 12, color: "#64748b" }}>
                                                            Pose 2 markers sur la carte. Mapbox calcule le chemin, puis clique sur Geofence line.
                                                        </div>
                                                    </div>
                                                )}

                                                {draftPoints.length > 0 && (
                                                    <div style={{
                                                        backgroundColor: "#fff",
                                                        border: "1px solid #d8dee4",
                                                        borderRadius: 6,
                                                        marginTop: 4,
                                                        padding: 8,
                                                        boxShadow: "0 8px 20px rgba(15, 23, 42, 0.10)"
                                                    }}>
                                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                                                            <span style={{ fontSize: 13, fontWeight: 600, color: "#1f2937" }}>
                                                                Points Mapbox ({draftPoints.length})
                                                            </span>
                                                            <div style={{ display: "flex", gap: 6 }}>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-primary"
                                                                    onClick={createPolygonFromDraftPoints}
                                                                    disabled={draftPoints.length < 2}
                                                                >
                                                                    Polygone
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary"
                                                                    onClick={() => setDraftPoints([])}
                                                                >
                                                                    Vider
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div style={{ marginTop: 6, maxHeight: 96, overflowY: "auto" }}>
                                                            {draftPoints.map((point, index) => (
                                                                <div
                                                                    key={`${point.id}-${index}`}
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        gap: 8,
                                                                        padding: "4px 0",
                                                                        borderTop: index === 0 ? 0 : "1px solid #f1f3f5"
                                                                    }}
                                                                >
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => mapRef.current?.setView(point.position, 16)}
                                                                        style={{
                                                                            border: 0,
                                                                            background: "transparent",
                                                                            padding: 0,
                                                                            color: "#334155",
                                                                            cursor: "pointer",
                                                                            fontSize: 12,
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                            whiteSpace: "nowrap",
                                                                            textAlign: "left"
                                                                        }}
                                                                    >
                                                                        {index + 1}. {point.label}
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-light"
                                                                        onClick={() => setDraftPoints((prev) => prev.filter((_, pointIndex) => pointIndex !== index))}
                                                                        aria-label="Supprimer le point"
                                                                    >
                                                                        <i className="las la-times"></i>
                                                                    </button>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}

                                                {geometrySearchResults.length > 0 && (
                                                    <div style={{
                                                        border: "1px solid #d8dee4",
                                                        boxShadow: "0 8px 20px rgba(15, 23, 42, 0.12)",
                                                        maxHeight: 180,
                                                        overflowY: "auto",
                                                        backgroundColor: "#fff",
                                                        marginTop: 4,
                                                        borderRadius: 6
                                                    }}>
                                                        {geometrySearchResults.map((geofence, index) => (
                                                            <button
                                                                key={`${geofence.id}-${index}`}
                                                                type="button"
                                                                onClick={() => focusGeofence(geofence)}
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    width: "100%",
                                                                    gap: 8,
                                                                    padding: "8px 10px",
                                                                    cursor: "pointer",
                                                                    border: 0,
                                                                    borderBottom: "1px solid #eee",
                                                                    background: "#fff",
                                                                    textAlign: "left"
                                                                }}
                                                            >
                                                                <span style={{
                                                                    width: 10,
                                                                    height: 10,
                                                                    borderRadius: "50%",
                                                                    backgroundColor: geofence.color || getGeofenceColor(geofence.type),
                                                                    display: "inline-block",
                                                                    flexShrink: 0
                                                                }} />
                                                                <span style={{ color: "#1f2937", fontSize: 13 }}>
                                                                    {geofence.type || "forme"} #{index + 1}
                                                                </span>
                                                            </button>
                                                        ))}
                                                    </div>
                                                )}

                                                {suggestions.length > 0 && (
                                                    <div style={{
                                                        border: "1px solid #ccc",
                                                        maxHeight: 250,
                                                        overflowY: "auto",
                                                        backgroundColor: "#fff",
                                                        marginTop: 2,
                                                        borderRadius: 4
                                                    }}>
                                                        {suggestions.map((feature: any) => (
                                                            <div
                                                                key={feature.id}
                                                                onClick={() => handleSelectSuggestion(feature)}
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    gap: 8,
                                                                    padding: "6px 10px",
                                                                    cursor: "pointer",
                                                                    borderBottom: "1px solid #eee"
                                                                }}
                                                            >
                                                                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                                    {feature.place_name}
                                                                </span>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-primary"
                                                                    onClick={(event) => {
                                                                        event.stopPropagation();
                                                                        addDraftPointFromFeature(feature);
                                                                    }}
                                                                    title="Ajouter comme point"
                                                                >
                                                                    <i className="las la-plus"></i>
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>

                                            <LayersControl position="topright">
                                                {baseMapOptions.map((option, index) => (
                                                    <LayersControl.BaseLayer
                                                        key={option.value}
                                                        name={option.label}
                                                        checked={index === 0} // Check the first layer by default
                                                    >
                                                        <TileLayer
                                                            url={option.icon}
                                                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                                        />
                                                    </LayersControl.BaseLayer>
                                                ))}
                                            </LayersControl>



                                            <FeatureGroup ref={featureGroupRef}>
                                                <EditControl
                                                    ref={editControlRef}
                                                    position="topleft"
                                                    onCreated={handleCreated}
                                                    onEdited={handleEdited}
                                                    onDeleted={handleDeleted}
                                                    onEditStop={() => setEditingGeofenceId(null)}
                                                    draw={{
                                                        rectangle: true,
                                                        polygon: true,
                                                        circle: true,
                                                        polyline: true,
                                                        marker: true,
                                                        circlemarker: false,
                                                    }}


                                                />

                                            </FeatureGroup>
                                        </MapContainer>

                                        <div className={`poi-trace-drawer ${traceDrawerOpen && selectedGeofence ? "is-open" : ""}`}>
                                            {selectedGeofence && (
                                                <>
                                                    <div className="poi-trace-drawer__header">
                                                        <div>
                                                            <div className="poi-trace-drawer__eyebrow">
                                                                {getGeofenceLabel(selectedGeofence, geofences.findIndex((geofence) => geofence.id === selectedGeofence.id))}
                                                            </div>
                                                            <div className="poi-trace-drawer__title">
                                                                {getGeofenceDisplayName(selectedGeofence, geofences.findIndex((geofence) => geofence.id === selectedGeofence.id))}
                                                            </div>
                                                        </div>
                                                        <button
                                                            type="button"
                                                            className="poi-trace-drawer__close"
                                                            onClick={() => setTraceDrawerOpen(false)}
                                                            aria-label="Fermer le drawer"
                                                        >
                                                            <i className="las la-times"></i>
                                                        </button>
                                                    </div>
                                                    <div className="poi-trace-drawer__body">
                                                        <div className="poi-trace-drawer__status">
                                                            {recalculatingGeofenceId === selectedGeofence.id
                                                                ? "Calcul du plus court chemin en cours."
                                                                : mapboxEditingGeofenceId === selectedGeofence.id
                                                                    ? "Deplace le point de depart ou d'arrivee sur la carte. Le trajet se recalcule automatiquement."
                                                                    : editingGeofenceId === selectedGeofence.id
                                                                        ? "Modification active. Deplace les points du trace puis clique sur Save dans la barre de la carte."
                                                                        : "Choisis l'action a appliquer sur ce trace."}
                                                        </div>
                                                        <div className="poi-trace-drawer__actions">
                                                            <button
                                                                type="button"
                                                                className={`poi-trace-drawer__button poi-trace-drawer__button--geofence ${editingGeofenceId === selectedGeofence.id ? "is-active" : ""}`}
                                                                onClick={() => startEditMode(selectedGeofence)}
                                                            >
                                                                <i className="las la-pen"></i>
                                                                Modifier le trace
                                                            </button>
                                                            {selectedGeofence.type === "polyline" && (
                                                                <>
                                                                    <button
                                                                        type="button"
                                                                        className="poi-trace-drawer__button poi-trace-drawer__button--mapbox"
                                                                        onClick={() => recalculateRouteGeofence(selectedGeofence)}
                                                                        disabled={recalculatingGeofenceId === selectedGeofence.id}
                                                                    >
                                                                        <i className="las la-route"></i>
                                                                        {recalculatingGeofenceId === selectedGeofence.id ? "Calcul en cours..." : "Calculer le plus court chemin"}
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className={`poi-trace-drawer__button poi-trace-drawer__button--optimized ${mapboxEditingGeofenceId === selectedGeofence.id ? "is-active" : ""}`}
                                                                        onClick={() => startMapboxRouteEdit(selectedGeofence)}
                                                                    >
                                                                        <i className="las la-map-marked-alt"></i>
                                                                        Ajuster le chemin
                                                                    </button>
                                                                    {mapboxEditingGeofenceId === selectedGeofence.id && (
                                                                        <button
                                                                            type="button"
                                                                            className="poi-trace-drawer__button poi-trace-drawer__button--finish"
                                                                            onClick={stopMapboxRouteEdit}
                                                                        >
                                                                            <i className="las la-check"></i>
                                                                            Terminer l'ajustement
                                                                        </button>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {step === 2 && (
                        <div
                            className="step-pane panel panel-default"
                            id="step2"
                            style={{ marginTop: "5px" }}
                        >
                            <div className="panel-body">
                                <div className="row">
                                    <div
                                        className="col-md-12"
                                        id="alarm_text2"
                                        style={{ marginBottom: "15px" }}
                                    ></div>
                                </div>
                                <div
                                    className="row"
                                    id="criteria"
                                    style={{ display: "block" }}
                                >
                                    <div className="col-md-12 col-sm-12" style={{ marginTop: "2px" }} >
                                        <div className="row">
                                            <div className="col-md-6 col-sm-6" style={{ marginTop: "2px" }}>
                                                <div className="input-group">
                                                    <span className="input-group-addon" style={{ paddingRight: " 10px" }}>
                                                        <strong>Etape 2 </strong> Complétez les informations du POI :
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="ccol-md-6 col-sm-6" style={{ display: "inline", textAlign: "right", margin: "8px 0" }}>
                                                <button className="btn btn-outline-secondary  mr-2" type="button" name="back" onClick={wizardBack}>
                                                    <i className="fas fa-chevron-left" style={{ color: "#ff7e41" }}></i>&nbsp;Précédent
                                                </button>

                                                <Button
                                                    onClick={() => {
                                                        setButtonClicked(true);

                                                        id_poi ? updatePOI(POI) : createPOI(POI);

                                                    }}
                                                    variant="primary"
                                                    type="submit"
                                                    disabled={buttonClicked}
                                                >
                                                    {id_poi ? translate("Save changes") : translate("Create POI")}
                                                </Button>
                                            </div>
                                        </div>
                                        <div className="row" style={{ marginTop: "2px" }}>
                                            <div className="col-md-6 col-sm-12">
                                                <label htmlFor="code_poi">Code POI :</label>
                                                <input
                                                    className="form-control"
                                                    name="codegeof"
                                                    id="codegeof"
                                                    placeholder="Code zone"
                                                    title="Code POI"
                                                    value={POI?.codegeof || ""}
                                                    onChange={(e) => handleChange(e.target.name, e.target.value)}
                                                />
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <label htmlFor="code_poi">Nom POI :</label>
                                                <input
                                                    className="form-control"
                                                    name="namegeof"
                                                    id="namegeof"
                                                    placeholder="Nom ( * : obligatoire)"
                                                    onKeyUp={verifyUsername}
                                                    title="Nom POI"
                                                    value={POI?.namegeof || ""}
                                                    onChange={(e) => handleChange(e.target.name, e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div className="col-md-6 col-sm-12">
                                                <label htmlFor="id_user">Utilisateur :</label>
                                                <Selectlist
                                                    controlId="user"
                                                    name="user_id"
                                                    id="user_id"
                                                    label={translate("User")}
                                                    icon="user"
                                                    options={usersOptions}
                                                    valueType={{
                                                        value: user?.id_user,
                                                        label: findUserById(user?.id_user || 0)?.label || translate("None"),
                                                    }}
                                                    onChange={(selectedOption) => handleChange("user_id", selectedOption?.value)}
                                                />
                                            </div>

                                            <div className="col-md-6 col-sm-12">
                                                <label htmlFor="surface_poi">  {geometryMetric.type === 'Longueur' ? 'Longueur (Km)' : 'Surface (Km)²'}</label>
                                                <input
                                                    className="form-control"
                                                    name="surface_poi"
                                                    id="surface_poi"
                                                    value={(geometryMetric.value).toFixed(2)}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="col-md-6 col-sm-12">
                                                <label htmlFor="surface_poi"> Tolérance (m): </label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    name="tolerance"
                                                    id="tolerance"
                                                    value={POI?.tolerance || "0"}
                                                    onChange={(e) => handleChange(e.target.name, e.target.value)}
                                                />
                                            </div>

                                            <div className="col-md-6 col-sm-12">
                                                <label htmlFor="surface_poi">Area Data</label>
                                                <input
                                                    className="form-control"
                                                    name="areaData"
                                                    id="areaData"
                                                    value={POI?.areageof || ""}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="col-md-6 col-sm-12">
                                                <label htmlFor="etatgeof">État Géofence</label>
                                                <div className="input-group">
                                                    <select
                                                        id="etatgeof"
                                                        name="etatgeof"
                                                        className="form-control"
                                                        value={POI?.etatgeof ?? ""}
                                                        onChange={(e) => handleChange(e.target.name, e.target.value)}
                                                    >
                                                        <option value="Active">Actif</option>
                                                        <option value="Inactive">Inactif</option>
                                                    </select>
                                                    <span className="input-group-text">
                                                        {POI?.etatgeof === "Active" ? (
                                                            <i className="fa fa-check-circle text-success" title="Actif"></i>
                                                        ) : (
                                                            <i className="fa fa-check-circle text-danger" title="Inactif"></i>
                                                        )}
                                                    </span>
                                                </div>
                                            </div>


                                            <div className="col-md-6 col-sm-12">
                                                <label htmlFor="code_poi">Description : </label>
                                                <textarea
                                                    className="form-control"
                                                    id="descriptiongeof"
                                                    name="descriptiongeof"
                                                    placeholder="Description"
                                                    title="Description"
                                                    value={POI?.descriptiongeof || ""}
                                                    onChange={(e) => handleChange(e.target.name, e.target.value)}
                                                />
                                            </div>





                                        </div>
                                    </div>
                                    <div
                                        className="col-md-3 col-sm-3"
                                        id="opts_cell"
                                        style={{ display: "none", marginTop: "2px" }}
                                    ></div>
                                    <div
                                        className="col-md-3 col-sm-3"
                                        id="extra_cell_inline"
                                        style={{ display: "none", marginTop: "2px" }}
                                    ></div>
                                </div>

                                <div className="row" style={{ display: "none" }}>
                                    <div
                                        className="col-md-12"
                                        id="extra_cell"
                                        style={{ marginTop: "10px" }}
                                    ></div>
                                </div>
                            </div>
                        </div>
                    )}
                </form>
            </div>
        </>
    );
};

export default POI;
